/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { TransmittalRecordInputDto } from './transmittalRecordInputDto.schema';

export const ReleaseTransmittalRecord = zod.object({
  "id": zod.string().uuid().optional(),
  "payload": zod.lazy(() => TransmittalRecordInputDto).optional()
});

export type ReleaseTransmittalRecord = zod.input<typeof ReleaseTransmittalRecord>;
export type ReleaseTransmittalRecordOutput = zod.output<typeof ReleaseTransmittalRecord>;
